import request from '@/system/engine/request';
import config from '@/system/engine/config';
import {getLocalStorage} from '@/system/store/localstorage';
var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';

// bonusRate
export function bonusRateAjaxTable(limit,pagination,id,run_at,group_id,GCA,USDT,BTC,ETH,LTC,BCHABC,DASH){
	const data = request({
		url: config.url+'bonusrate/ajaxTable?language='+language+'&limit=' + limit + '&pagination=' + pagination + '&id=' + id + '&run_at=' + run_at + '&group_id=' + group_id + '&GCA=' + GCA + '&USDT=' + USDT + '&BTC=' + BTC + '&ETH=' + ETH + '&LTC=' + LTC + '&BCHABC=' + BCHABC + '&DASH=' + DASH,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function getBonusRateEdit(id){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'bonusrate/edit?language='+language+'&id='+id,
		method: 'get',
	});

	return Promise.resolve(data);
}

export function bonusRateEdit(postData){
	const data = request({
		url: config.url+'bonusrate/edit',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}